import type { ComponentProps } from "react";
import { Button } from "react-aria-components";
import { cn } from "@/shared/lib/cn";
import { HomeIcon } from "./MerchantHomePrimitives";

type RailCardActionButtonProps = Omit<ComponentProps<typeof Button>, "children" | "aria-label"> & {
  icon: string;
  label: string;
};

export function RailCardActionButton({ icon, label, className, ...props }: RailCardActionButtonProps) {
  return <Button {...props} aria-label={label} className={cn("merchant-home-rail__action-button", className)}><HomeIcon src={icon} /></Button>;
}

/** Keep pointerdown propagation so document-level drag listeners receive handle presses. */
export function RailCardDragButton({
  icon, label, className, dragType, dragHandle, tabIndex,
}: {
  icon: string;
  label: string;
  className?: string;
  dragType?: string;
  dragHandle?: string;
  tabIndex?: number;
}) {
  return <Button onPressStart={(event) => event.continuePropagation()} excludeFromTabOrder={tabIndex === -1} type="button" aria-label={label} aria-keyshortcuts={dragHandle ? "ArrowUp ArrowDown" : undefined} className={cn("merchant-home-rail__action-button", "merchant-home-rail__drag", className)} data-workbench-drag-type={dragType} data-merchant-rail-drag-handle={dragHandle}><HomeIcon src={icon} /></Button>;
}
